export default __webpack_public_path__ + "static/AppMoneyWalkie1-af93b6c0131fbb57898f247aff9d4c90.png";